<template>
    <div class="login-container">
      <div class="content ">
        <div class="left">
          <div class="bg">
           <img src="@/assets/images/font.png" alt="" style="cursor: pointer;"  @click="openUrl"/>
          </div>
        </div>
        <div class="right-container">
        <div class="right">
          <div class="title">欢迎登录</div>
         <div class="manage" @click="openUrl">联控智慧房车管理平台</div>
        </div>
      </div>
      </div>
     <div class="bottom">
      <span class="company">嘉兴联控信息技术有限公司</span>
     <div style="display: flex;align-items: center; justify-content: center; gap:0 10px"> <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33040002330413" rel="noreferrer" style="color: #ffffff; display: flex;align-items: center;gap:0 10px;justify-content: center;" target="_blank">
        <img src="@/assets/images/icon.png"/>浙公网安备33040002330413号</a>
        <a href="https://beian.miit.gov.cn/">浙ICP备2023043656号-1</a></div>
     </div>
    </div>
  </template>
  
  <script>

  export default {
    data() {
      return {
        form: {
          username: '',
          password: '',
          code: '',
          checked: false,
        },
        data: {
          code_img: '',
        },
      };
    },
    created() {
   
    },
    methods: {
      openUrl(){
        window.open('https://rv.lancontral.com')
      }
    },
  };
  </script>
  
  <style lang="less" scoped>
  .login-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  
    justify-content: space-between;
     
       background: rgba(53, 57, 64, 0.85);
       color: #fff;
    .content {
     width: 100%;
     height: 92%;
      display: flex;
    background-image: url('~@/assets/images/login-bg1.jpg');
    background-size: cover;
      background-position: center;
      align-items: center;
    }
    .left {
      float: left;
      width:70%;
      height: 90%;
   
  
     .bg{
        width: 80%;
        margin: 0 auto;
        margin-top: 10vh;
        img{
          width: 100%;
        }
     
     }
    }
    .right-container{
      width: 35%;
      height: 100%;
      display: flex;
      align-items: center;
      background: rgba(53, 57, 64, 0.85);
      justify-content: center;
    }
    .right {
      width:400px;
      height: 50%;
      padding: 50px 50px;
      // margin-right: 30px;
      .title {
        font-size: 32px;
        color: #fff;
        padding-bottom: 48px;
        text-align: center;
      }
      .manage{
        cursor: pointer;
        font-size: 20px;
        text-align: center;

      }
    }
    .bottom {
      position: absolute;
      bottom: 10px;
      left: 0;
      right: 0;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .company{
        margin: 10px 0;
        font-size: 20px;
      }
      a{
        color: #fff;
      }
    }
  }
  .btn{
    margin-top: 48px;
  }
  /deep/ .el-form-item__label{
    color: #fff;
  }
  </style>
  